
import Vue, { PropType } from 'vue';
import { mapState } from 'vuex';
import { Customer } from '@sageworks/jpi/';
import CustomerType = Customer.TypeEnum;
import { CustomComponentType } from '@sageworks/dynamic-forms';
import AddNewPrimaryRoleAccessPopup from '@/formio-vue/components/add-new-primary-role-access-popup/add-new-primary-role-access-popup.vue';
export default Vue.extend({
	name: 'AddNewPrimaryRole',
	components: {
		AddNewPrimaryRoleAccessPopup
	},
	props: {
		entityTypes: {
			type: Array as PropType<Customer.TypeEnum[]>,
			default: () => []
		},
		componentType: {
			type: String as PropType<CustomComponentType>
		},
		componentLabel: {
			type: String,
			default: () => ''
		},
		isLender: {
			type: Boolean,
			default: false
		},
		useBorrowerAccessRestrictions: {
			type: Boolean
		},
		allowBorrowerToSendInvites: {
			type: Boolean
		},
		loanApplicationId: {
			type: Number
		}
	},
	computed: {
		...mapState('MultiLoanApplicationForm', ['renderData'])
	},
	methods: {
		getLabel(item: CustomerType) {
			switch (item) {
				case CustomerType.Business:
					return 'Business';
				case CustomerType.Person:
					return 'Person';
				case CustomerType.Farm:
					return 'Farm';
				case CustomerType.NonProfit:
					return 'Nonprofit';
			}
			return item ? item + '' : '';
		},
		addNewEntity(entityType: Customer.TypeEnum) {
			this.$emit('add-entity', entityType);
		},
		addEntity(entityType: Customer.TypeEnum) {
			if (!this.isLender && this.useBorrowerAccessRestrictions && this.allowBorrowerToSendInvites && entityType === CustomerType.Person) {
				this.$bvModal.show(`can-fill-out-information-modal-${this.componentType}-${entityType}`);
				return;
			}
			this.addNewEntity(entityType);
		},
		handleEntityInvited(event: any) {
			this.$emit('entity-invited', event);
		}
	}
});
